<template>
    <el-card class="edit-userInfo">
        <el-form :rules="rules" :model="userInfo" ref="userForm">
            <div class="BaseInfoWrapper">
                <div class="upload_avatar">
                    <el-avatar :size="83" :src="userInfo.iconPath" class="avatar"/>
                    <el-button round size="mini" type="primary" class="avatarBtn" @click="visibleUpload = true">上传头像
                    </el-button>
                </div>
                <div class="editBaseInfo">
                    <h4>基本信息</h4>
                    <el-form-item label="昵称：" prop="nickName">
                        <el-input v-model="userInfo.nickName" size="small" placeholder="请输入昵称"/>
                    </el-form-item>
                    <el-form-item label="角色：" prop="userType">
                        <el-select v-model="userInfo.userType" class="select" size="small" placeholder="请选择">
                            <el-option v-for="item in userTypeList" :key="item.id" :label="item.key" :value="item.id"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学校：" prop="schoolName">
                        <el-autocomplete v-model="userInfo.schoolName" size="small"
                                         :fetch-suggestions="querySearchAsync"
                                         placeholder="请输入内容"
                                         :trigger-on-focus="false"
                                         @select="handleSelect"/>
                        <p class="tips">例：中国人民大学附属中学<br/>学校查询不到请发送至邮箱lianmeng@cdeledu.com</p>
                    </el-form-item>
                    <el-form-item :label="disTitle" prop="subjectID">
                        <el-select v-model="userInfo.subjectID" class="select" size="small" placeholder="请选择">
                            <el-option v-for="item in subjectList" :key="item.subjectId" :label="item.subName"
                                       :value="item.subjectId"/>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="moreInfo">
                <h4>更多信息</h4>
                <el-form-item label="真实姓名：" prop="realName">
                    <el-input v-model="userInfo.realName" size="small" placeholder="请输入真实姓名"/>
                </el-form-item>
                <el-form-item label="生日:" prop="birthday">
                    <el-date-picker v-model="userInfo.birthday" sizt="small" type="date" :value-format="'yyyyMMdd'"/>
                </el-form-item>
                <el-form-item label="所在地:" prop="birthday">
                    <div v-if="isEditArea">
                        <el-select v-model="areaObject.provinceID" class="select" size="mini" placeholder="请选择"
                                   @change="((val)=>{changeArea(val, 0)})">
                            <el-option
                                    v-for="item in areaObject.provinceList"
                                    :key="item.areaID"
                                    :label="item.areaName"
                                    :value="item.areaID"
                            />
                        </el-select>
                        省
                        <el-select v-model="areaObject.cityID" class="select" size="mini" placeholder="请选择"
                                   @change="((val)=>{changeArea(val, 1)})">
                            <el-option
                                    v-for="item in areaObject.cityList"
                                    :key="item.areaID"
                                    :label="item.areaName"
                                    :value="item.areaID"
                            />
                        </el-select>
                        市
                        <el-select v-model="areaObject.countyID" class="select" size="mini" placeholder="请选择"
                                   @change="((val)=>{changeArea(val, 2)})">
                            <el-option
                                    v-for="item in areaObject.countyList"
                                    :key="item.areaID"
                                    :label="item.areaName"
                                    :value="item.areaID"
                            />
                        </el-select>
                        区/县
                    </div>
                    <p class="editArea" v-else @click="isEditArea = true">{{ userInfo.area }}</p>
                </el-form-item>
            </div>
        </el-form>
        <el-button type="primary" round size="small" class="submitBtn" @click="save" :loading="subLoading">保&#12288;存
        </el-button>
        <upload-avatar :visible="visibleUpload" @close="visibleUpload = false" @uploadSuccess="uploadSuccess"/>
    </el-card>
</template>
<script>
  import { getUserInfo, searchSchool, getSubjectList, getArea, modifyUser } from '@/api/user';
  import uploadAvatar from '@/components/User/uploadAvatar';

  export default {
    name: 'EditUserInfo',
    components: {
      uploadAvatar
    },
    data () {
      return {
        visibleUpload: false,
        userNo: '',
        disTitle: '关注学科：',
        userInfo: {
          nickName: '',
          userType: 2,
          schoolID: '',
          schoolName: '',
          subjectID: '',
          realName: '',
          birthday: '',
          area: '',
          areaID: '',
          iconPath: ''
        },
        isEditArea: false,
        subjectList: [],
        timeout: null,
        subLoading: false,
        areaObject: {
          provinceID: '',
          cityID: '',
          countyID: '',
          provinceList: [],
          cityList: [],
          countyList: []
        },
        //角色类型
        userTypeList: [
          { id: 0, key: '家长' },
          { id: 1, key: '教师' },
          { id: 2, key: '学生' }
        ],
        rules: {
          nickName: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
          userType: [{ required: true, message: '请选择角色', trigger: 'change' }],
          schoolName: [{ required: true, message: '请选择学校', trigger: ['change'] }],
          subjectID: [{ required: true, message: '请选择主讲科目', trigger: ['blur', 'change'] }],
        },
        upload_url: ''
      };
    },
    watch: {
      'userInfo.userType': function () {
        if (this.userInfo.userType === 1) {
          this.disTitle = '主讲学科：';
        } else {
          this.disTitle = '关注学科：';
        }
      }
    },
    async mounted () {
      const { userNo } = this.$route.query;
      this.userNo = userNo;
      await this.getBaseInfo(userNo);
      await this.getUserSubjectList(userNo);
      await this.initArea();
    },
    methods: {
      async getBaseInfo (id) {
        await getUserInfo(id).then(data => {
          if (data.success) {
            const { nickName, userType, subject, subjectID, realName, birthday, areaID, area, school, iconPath } = data.result;
            this.userInfo = {
              nickName: nickName,
              userType: userType,
              subject: subject,
              subjectID: subjectID,
              realName: realName,
              birthday: String(birthday) || 0,
              areaID: areaID,
              area: area,
              schoolName: school,
              iconPath: iconPath ? iconPath : ''
            };
            if (!areaID || !area) {
              this.isEditArea = true;
            }
          } else {
            this.$message({
              type: 'error',
              message: data.errorMsg
            });
          }
        });
      },
      async getUserSubjectList (id) {
        await getSubjectList(id).then(data => {
          if (data.success) {
            const { subjects } = data.result;
            this.subjectList = subjects;
          } else {
            this.$message({
              type: 'error',
              message: data.errorMsg
            });
          }
        });
      },
      async querySearchAsync (queryString, cb) {
        if (queryString) {
          await searchSchool(queryString).then(data => {
            const { schoolList } = data.result;
            let results = [];
            schoolList.forEach(item => {
              results.push({
                id: item.schoolID,
                value: item.schoolName
              });
            });
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              cb(results);
            }, 3000 * Math.random());
          });
        }
      },
      handleSelect (item) {
        this.userInfo.schoolID = item.id;
        this.userInfo.schoolName = item.value;
      },
      async initArea () {
        await getArea(0).then(data => {
          if (data.success) {
            this.areaObject.provinceID = 10;
            this.areaObject.provinceList = data.result;
          }
        });
      },
      async changeArea (id, type) {
        await getArea(id).then(data => {
          if (type === 0) {
            this.areaObject.provinceID = id;
            this.areaObject.cityID = '';
            this.areaObject.countyID = '';
            this.areaObject.countyList = [];
            this.areaObject.cityList = data.result;
          } else if (type === 1) {
            this.areaObject.cityID = id;
            this.areaObject.countyID = '';
            this.areaObject.countyList = data.result;
          } else if (type === 2) {
            this.userInfo.areaID = id;
          }
        });
      },
      uploadSuccess (data) {
        this.visibleUpload = false;
        this.userInfo.iconPath = data;
      },
      save () {
        this.$refs.userForm.validate(valid => {
          if (valid) {
            this.subLoading = true;
            const { nickName, userType, schoolID, subjectID, realName, birthday, areaID, iconPath } = this.userInfo;
            const params = {
              userNo: this.userNo,
              nickName: nickName,
              realName: realName || '',
              birthday: birthday || '',
              userType: userType,
              areaID: this.areaObject.countyID || areaID,
              iconPath: iconPath !== '/styles/default_avatar.png' ? iconPath : '',
              schoolID: schoolID,
              subjectID: subjectID,
            };
            modifyUser(params).then(data => {
              if (data.success && data.result.result === 'success') {
                this.$message({
                  type: 'success',
                  message: '修改成功',
                  duration: 1500,
                  onClose: () => {
                    this.$router.push('/u/info');
                    window.location.reload();
                  }
                });
                this.subLoading = false;
              } else {
                this.$message({
                  type: 'error',
                  message: data.errorMsg
                });
              }
            });
          }
        });

      }
    }
  };
</script>
<style lang="scss">
    .tips{
        width: 320px;
        position: absolute;
        top: 0;
        left: 215px;
        line-height: 20px;
        color: #a8a8a8;
    }
</style>
